import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import ReviewQueueList from 'components/ReviewQueue/List';

const ScreenReviewQueueList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <ReviewQueueList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenReviewQueueList;
